import React from 'react'

const SvgTShirtFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12 6a2 2 0 01-2-2h4a2 2 0 01-2 2z' />
    <path d='M19.188 5.781A4 4 0 0015.858 4h-.526c0 1.894-1.492 3.429-3.333 3.429-1.84 0-3.333-1.535-3.333-3.429H8.14a4 4 0 00-3.328 1.781L2 10l3.5 3 .944-1v6a2 2 0 002 2h7.112a2 2 0 002-2v-6l.944 1 3.5-3-2.813-4.219z' />
  </svg>
)

export default SvgTShirtFilled
